var _pattern, _pattern2, _clipPath, _pattern3, _clipPath2, _feGaussianBlur;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmentSafetySystemC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "111.71mm",
    height: "71.469mm",
    viewBox: "0 0 111.71 71.469",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "TriangleInL",
    style: {
      overflow: "visible"
    },
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(-.8)",
    d: "m5.77 0-8.65 5v-10z",
    style: {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      stroke: "#000"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    style: {
      overflow: "visible"
    },
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.8)",
    d: "m5.77 0-8.65 5v-10z",
    style: {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      stroke: "#000"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "TriangleOutL",
    style: {
      overflow: "visible"
    },
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "scale(.8)",
    d: "m5.77 0-8.65 5v-10z",
    style: {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      stroke: "#000"
    }
  })), /*#__PURE__*/React.createElement("marker", {
    id: "Arrow1Lstart",
    style: {
      overflow: "visible"
    },
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.8 0 0 .8 10 0)",
    d: "m0 0 5-5-17.5 5 17.5 5z",
    style: {
      fillRule: "evenodd",
      strokeWidth: "1pt",
      stroke: "#000"
    }
  })), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "EMFhbasepattern",
    width: 6,
    height: 6,
    patternUnits: "userSpaceOnUse"
  })), _pattern2 || (_pattern2 = /*#__PURE__*/React.createElement("pattern", {
    width: 6,
    height: 6,
    patternUnits: "userSpaceOnUse"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("path", {
    d: "m4.1598 3.5198h74.556v50.237h-74.556z"
  }))), _pattern3 || (_pattern3 = /*#__PURE__*/React.createElement("pattern", {
    width: 6,
    height: 6,
    patternUnits: "userSpaceOnUse"
  })), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("path", {
    d: "m4.4798 4.4798h147.83v244.31h-147.83z"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter2461",
    x: -0.023066,
    y: -0.037143,
    width: 1.0461,
    height: 1.0743,
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.24574489
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33.487 -67.826)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "matrix(.80298 0 0 .79922 20.339 28.777)",
    d: "m67.56 121.81v6.8139c0 3.8366 2.9785 6.947 6.6525 6.947h14.257v2.1179l4.6594-5.1306-4.6594-5.1306v2.1179h-14.257c-0.48632 0-0.88133-0.41249-0.88133-0.92146v-6.8139z",
    style: {
      fillOpacity: 0.7,
      fillRule: "evenodd",
      filter: "url(#filter2461)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.753 98.578-2.1712 1.5251v10.444l2.1712-1.5251z",
    style: {
      fillRule: "evenodd",
      fill: "#1b7387",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "bevel",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.582 100.1h-4.8288v10.444h4.8288z",
    style: {
      fill: "#2396af",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "bevel",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.753 98.578-2.1712 1.5251h-4.8288l2.1712-1.5251z",
    style: {
      fill: "#29b0ce",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "bevel",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.831 82.713-2.1712 1.5251v26.309l2.1712-1.5251z",
    style: {
      fillRule: "evenodd",
      fill: "#1b7387",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "bevel",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.659 84.238h-4.8028v26.309h4.8028z",
    style: {
      fill: "#2396af",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "bevel",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.831 82.713-2.1712 1.5251h-4.8028l2.1453-1.5251z",
    style: {
      fill: "#29b0ce",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "bevel",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.577 69.745-2.0847 1.5663v39.236l2.0847-1.5663z",
    style: {
      fillRule: "evenodd",
      fill: "#1b7387",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "bevel",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.492 71.311h-4.9166v39.236h4.9166z",
    style: {
      fill: "#2396af",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "bevel",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.577 69.745-2.0847 1.5663h-4.9166l2.0847-1.5663z",
    style: {
      fill: "#29b0ce",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "bevel",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.38 89.844-2.1499 1.5054v19.198l2.1499-1.5054z",
    style: {
      fillRule: "evenodd",
      fill: "#1b7387",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "bevel",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m102.23 91.349h-4.8612v19.198h4.8612z",
    style: {
      fill: "#2396af",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "bevel",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.38 89.844-2.1499 1.5054h-4.8612l2.1499-1.5054z",
    style: {
      fill: "#29b0ce",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "bevel",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.63 84.136-2.2267 1.5591v24.852l2.2267-1.5591z",
    style: {
      fillRule: "evenodd",
      fill: "#1b7387",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "bevel",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.403 85.695h-4.778v24.852h4.778z",
    style: {
      fill: "#2396af",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "bevel",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.63 84.136-2.2267 1.5591h-4.778l2.2267-1.5591z",
    style: {
      fill: "#29b0ce",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "bevel",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.35 97.178-2.159 1.5165v11.852l2.159-1.5165z",
    style: {
      fillRule: "evenodd",
      fill: "#1b7387",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "bevel",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.19 98.695h-4.8548v11.852h4.8548z",
    style: {
      fill: "#2396af",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "bevel",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.35 97.178-2.159 1.5165h-4.8548l2.159-1.5165z",
    style: {
      fill: "#29b0ce",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "bevel",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.21 101.67-2.193 1.5356v7.3428l2.193-1.5356z",
    style: {
      fillRule: "evenodd",
      fill: "#1b7387",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "bevel",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.01 103.2h-4.8186v7.3428h4.8186z",
    style: {
      fill: "#2396af",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "bevel",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m130.21 101.67-2.193 1.5356h-4.8186l2.193-1.5356z",
    style: {
      fill: "#29b0ce",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "bevel",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.44 107.26-2.2079 1.546v2.274l2.2079-1.546z",
    style: {
      fillRule: "evenodd",
      fill: "#1b7387",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "bevel",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.23 108.8h-4.8044v2.274h4.8044z",
    style: {
      fill: "#2396af",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "bevel",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.44 107.26-2.2079 1.546h-4.8044l2.2079-1.546z",
    style: {
      fill: "#29b0ce",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "bevel",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(39.741 -1.0785)",
    style: {
      strokeLinejoin: "round",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.3426 105.43-2.1712 1.5251-0.02584 7.3433 2.1712-1.5251z",
    style: {
      fillRule: "evenodd",
      fill: "#0ac29b",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.1714 106.96h-4.8288l-0.02584 7.3433h4.8288z",
    style: {
      fill: "#0bd6aa",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.3426 105.43-2.1712 1.5251h-4.8288l2.1712-1.5251z",
    style: {
      fill: "#52f6d2",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.142 97.053-2.3446 1.6417v15.605l2.3446-1.6417z",
    style: {
      fillRule: "evenodd",
      fill: "#0ac29b",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.797 98.695h-4.8028v15.605h4.8028z",
    style: {
      fill: "#0bd6aa",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.142 97.053-2.3446 1.6417h-4.8028l2.3446-1.6417z",
    style: {
      fill: "#52f6d2",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.136 81.828-2.1712 1.5251 0.0035 30.946 2.1712-1.5251z",
    style: {
      fillRule: "evenodd",
      fill: "#0ac29b",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.965 83.353h-4.8288l0.0035 30.946h4.8288z",
    style: {
      fill: "#0bd6aa",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.136 81.828-2.1712 1.5251h-4.8288l2.1712-1.5251z",
    style: {
      fill: "#52f6d2",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.353 89.857-2.1712 1.5251-0.0143 22.951 2.2267-1.5591z",
    style: {
      fillRule: "evenodd",
      fill: "#0ac29b",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.182 91.382h-4.8288l0.03654 22.951h4.778z",
    style: {
      fill: "#0bd6aa",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.353 89.857-2.1712 1.5251h-4.8288l2.1712-1.5251z",
    style: {
      fill: "#52f6d2",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.934 102.33-2.1712 1.5251 0.0234 10.455 2.159-1.5165z",
    style: {
      fillRule: "evenodd",
      fill: "#0ac29b",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.763 103.86h-4.8288l-3e-3 10.455h4.8548z",
    style: {
      fill: "#0bd6aa",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.934 102.33-2.1712 1.5251h-4.8288l2.1712-1.5251z",
    style: {
      fill: "#52f6d2",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.963 110.48-2.2079 1.546v2.274l2.2079-1.546z",
    style: {
      fillRule: "evenodd",
      fill: "#0ac29b",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.755 112.03h-4.8044v2.274h4.8044z",
    style: {
      fill: "#0bd6aa",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.963 110.48-2.2079 1.546h-4.8044l2.2079-1.546z",
    style: {
      fill: "#52f6d2",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 0.26458,
      stroke: "#000"
    }
  })), /*#__PURE__*/React.createElement("text", {
    transform: "rotate(-90)",
    x: -104.27194,
    y: 38.616947,
    style: {
      fill: "#ffffff",
      fontFamily: "Verdana",
      fontSize: "7.0556px",
      letterSpacing: 0,
      lineHeight: 1.25,
      strokeOpacity: 0.7,
      strokeWidth: 0,
      stroke: "#000000",
      wordSpacing: 0
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -104.27194,
    y: 38.616947,
    style: {
      fill: "#ffffff",
      fontFamily: "Verdana",
      fontSize: "7.0556px",
      strokeOpacity: 0.7,
      strokeWidth: 0,
      stroke: "#000000"
    }
  }, "Frequency")), /*#__PURE__*/React.createElement("text", {
    x: 59.91581,
    y: 122.31063,
    style: {
      fill: "#ffffff",
      fontFamily: "Verdana",
      fontSize: "7.0556px",
      letterSpacing: 0,
      lineHeight: 1.25,
      strokeOpacity: 0.7,
      strokeWidth: 0,
      stroke: "#000000",
      wordSpacing: 0
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 59.91581,
    y: 122.31063,
    style: {
      fill: "#ffffff",
      fontFamily: "Verdana",
      fontSize: "7.0556px",
      strokeOpacity: 0.7,
      strokeWidth: 0,
      stroke: "#000000"
    }
  }, "Collision Speed")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.79266 0 0 .78622 -14.566 68.016)",
    style: {
      strokeWidth: 1.2667
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.2667
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m147.15 79.082a5.1585 5.105 0 0 0-0.0704 0.0012 5.1585 5.105 0 0 0-5.0401 5.2171 5.1585 5.105 0 0 0 1.791 3.7542 5.17 5.0681 0 0 0 5e-3 0.0052 5.17 5.0681 0 0 0 3.5556 1.2864 5.17 5.0681 0 0 0 5.0563-5.1745v-0.01018a5.17 5.0681 0 0 0-1.1429-3.0619 5.1585 5.105 0 0 0-4.1551-2.0174z",
    style: {
      fill: "#e5ac09",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.15 79.082a5.1585 5.105 0 0 0-0.0706 1e-3 5.1585 5.105 0 0 0-5.0399 5.2173 5.1585 5.105 0 0 0 2.0534 3.9639 5.4941 5.5416 0 0 0 2.3072 0.45692 5.4941 5.5416 0 0 0 5.3734-5.6579l-2.9e-4 -0.01104a5.4941 5.5416 0 0 0-0.32788-1.7609 5.1585 5.105 0 0 0-4.2953-2.2094z",
    style: {
      fill: "#edd720",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.21 82.638a0.49954 0.85389 0 0 1-0.48856 0.87184 0.49954 0.85389 0 0 1-0.51029-0.83468 0.49954 0.85389 0 0 1 0.48806-0.87266 0.49954 0.85389 0 0 1 0.51077 0.83382",
    style: {
      fill: "#483e37",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m144.55 84.919a2.7812 2.5332 0 0 0 2.8365 2.3804 2.7812 2.5332 0 0 0 2.7154-2.3804z",
    style: {
      fill: "#483e37",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.25 85.972a2.7812 2.5332 0 0 0-1.855 0.63463 2.7812 2.5332 0 0 0 1.9784 0.69809 2.7812 2.5332 0 0 0 1.7802-0.63384 2.7812 2.5332 0 0 0-1.8574-0.69835 2.7812 2.5332 0 0 0-0.0464-5.6e-4z",
    style: {
      fill: "#f07768",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.67 80.431c-3.1796-2.6439-7.4108 0.53648-6.7493 3.7608 0.0439-3.3918 3.766-5.2175 6.7493-3.7608z",
    style: {
      fill: "#fcf2c8",
      fontVariationSettings: "normal",
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.21 82.638a0.49954 0.85389 0 0 1-0.48856 0.87184 0.49954 0.85389 0 0 1-0.51029-0.83468 0.49954 0.85389 0 0 1 0.48806-0.87266 0.49954 0.85389 0 0 1 0.51077 0.83382",
    style: {
      fill: "#483e37",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.15 79.081a5.1585 5.105 0 0 0-0.0704 0.0012 5.1585 5.105 0 0 0-5.0401 5.2171 5.1585 5.105 0 0 0 1.791 3.7542 5.17 5.0681 0 0 0 5e-3 0.0052 5.17 5.0681 0 0 0 3.5556 1.2864 5.17 5.0681 0 0 0 5.0563-5.1745v-0.01016a5.17 5.0681 0 0 0-1.1429-3.0619 5.1585 5.105 0 0 0-4.1551-2.0174z",
    style: {
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 0.50669,
      stroke: "#000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.66129 0 0 .65443 50.992 33.484)",
    style: {
      strokeWidth: 1.9256
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m193.55 69.625a7.8007 7.8007 0 0 0-0.10644 0.0018 7.8007 7.8007 0 0 0-7.6216 7.972 7.8007 7.8007 0 0 0 2.7084 5.7367 7.818 7.7443 0 0 0 8e-3 8e-3 7.818 7.7443 0 0 0 5.3767 1.9656 7.818 7.7443 0 0 0 7.6461-7.9069v-0.01556a7.818 7.7443 0 0 0-1.7282-4.6788 7.8007 7.8007 0 0 0-6.2833-3.0827z",
    style: {
      fill: "#d2c07f",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.55 69.625a7.8007 7.8007 0 0 0-0.10682 0.0016 7.8007 7.8007 0 0 0-7.6212 7.9723 7.8007 7.8007 0 0 0 3.1052 6.0571 8.3081 8.4679 0 0 0 3.489 0.6982 8.3081 8.4679 0 0 0 8.1255-8.6455l-4.5e-4 -0.01687a8.3081 8.4679 0 0 0-0.49581-2.6908 7.8007 7.8007 0 0 0-6.4953-3.376z",
    style: {
      fill: "#d0cfac",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.12 75.06a0.75541 1.3048 0 0 1-0.7388 1.3322 0.75541 1.3048 0 0 1-0.77165-1.2754 0.75541 1.3048 0 0 1 0.73803-1.3335 0.75541 1.3048 0 0 1 0.77239 1.2741",
    style: {
      fill: "#404040",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m189.61 78.545a4.2056 3.8709 0 0 0 4.2893 3.6374 4.2056 3.8709 0 0 0 4.1062-3.6374z",
    style: {
      fill: "#404040",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.69 80.153a4.2056 3.8709 0 0 0-2.8051 0.96974 4.2056 3.8709 0 0 0 2.9918 1.0667 4.2056 3.8709 0 0 0 2.692-0.96854 4.2056 3.8709 0 0 0-2.8087-1.0671 4.2056 3.8709 0 0 0-0.0701-8.55e-4z",
    style: {
      fill: "#c9948f",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m197.21 71.686c-4.8082-4.04-11.207 0.81976-10.206 5.7467 0.0664-5.1829 5.695-7.9727 10.206-5.7467z",
    style: {
      fill: "#eaeacd",
      fontVariationSettings: "normal",
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.65 75.06a0.75541 1.3048 0 0 1-0.7388 1.3322 0.75541 1.3048 0 0 1-0.77165-1.2754 0.75541 1.3048 0 0 1 0.73803-1.3335 0.75541 1.3048 0 0 1 0.77239 1.2741",
    style: {
      fill: "#404040",
      paintOrder: "markers fill stroke"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m178.98 79.049a5.1585 5.105 0 0 0-0.0704 0.0012 5.1585 5.105 0 0 0-5.0401 5.2171 5.1585 5.105 0 0 0 1.791 3.7542 5.17 5.0681 0 0 0 6e-3 0.0052 5.17 5.0681 0 0 0 3.5556 1.2864 5.17 5.0681 0 0 0 5.0563-5.1745v-0.01015a5.17 5.0681 0 0 0-1.1429-3.0619 5.1585 5.105 0 0 0-4.1551-2.0174z",
    style: {
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 0.50669,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.2667
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m157.76 79.082a5.1585 5.105 0 0 0-0.0704 0.0012 5.1585 5.105 0 0 0-5.0401 5.2171 5.1585 5.105 0 0 0 1.791 3.7542 5.17 5.0681 0 0 0 5e-3 0.0052 5.17 5.0681 0 0 0 3.5556 1.2864 5.17 5.0681 0 0 0 5.0563-5.1745v-0.01018a5.17 5.0681 0 0 0-1.1429-3.0619 5.1585 5.105 0 0 0-4.1551-2.0174z",
    style: {
      fill: "#e5ac09",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.76 79.082a5.1585 5.105 0 0 0-0.0706 1e-3 5.1585 5.105 0 0 0-5.0399 5.2173 5.1585 5.105 0 0 0 2.0534 3.9639 5.4941 5.5416 0 0 0 2.3072 0.45692 5.4941 5.5416 0 0 0 5.3734-5.6579l-2.9e-4 -0.01104a5.4941 5.5416 0 0 0-0.32788-1.7609 5.1585 5.105 0 0 0-4.2953-2.2094z",
    style: {
      fill: "#edd720",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.82 82.638a0.49954 0.85389 0 0 1-0.48856 0.87184 0.49954 0.85389 0 0 1-0.51029-0.83468 0.49954 0.85389 0 0 1 0.48806-0.87266 0.49954 0.85389 0 0 1 0.51077 0.83382",
    style: {
      fill: "#483e37",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.16 84.919a2.7812 2.5332 0 0 0 2.8365 2.3804 2.7812 2.5332 0 0 0 2.7154-2.3804z",
    style: {
      fill: "#483e37",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.86 85.972a2.7812 2.5332 0 0 0-1.855 0.63463 2.7812 2.5332 0 0 0 1.9784 0.69809 2.7812 2.5332 0 0 0 1.7802-0.63384 2.7812 2.5332 0 0 0-1.8574-0.69835 2.7812 2.5332 0 0 0-0.0464-5.6e-4z",
    style: {
      fill: "#f07768",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.28 80.431c-3.1797-2.6439-7.4108 0.53648-6.7493 3.7608 0.0439-3.3918 3.766-5.2175 6.7493-3.7608z",
    style: {
      fill: "#fcf2c8",
      fontVariationSettings: "normal",
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.82 82.638a0.49954 0.85389 0 0 1-0.48857 0.87184 0.49954 0.85389 0 0 1-0.51028-0.83468 0.49954 0.85389 0 0 1 0.48805-0.87266 0.49954 0.85389 0 0 1 0.51077 0.83382",
    style: {
      fill: "#483e37",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157.76 79.081a5.1585 5.105 0 0 0-0.0704 0.0012 5.1585 5.105 0 0 0-5.0401 5.2171 5.1585 5.105 0 0 0 1.791 3.7542 5.17 5.0681 0 0 0 5e-3 0.0052 5.17 5.0681 0 0 0 3.5556 1.2864 5.17 5.0681 0 0 0 5.0563-5.1745v-0.01016a5.17 5.0681 0 0 0-1.1429-3.0619 5.1585 5.105 0 0 0-4.1551-2.0174z",
    style: {
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 0.50669,
      stroke: "#000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 1.2667
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m168.37 79.082a5.1585 5.105 0 0 0-0.0704 0.0012 5.1585 5.105 0 0 0-5.0401 5.2171 5.1585 5.105 0 0 0 1.791 3.7542 5.17 5.0681 0 0 0 5e-3 0.0052 5.17 5.0681 0 0 0 3.5556 1.2864 5.17 5.0681 0 0 0 5.0563-5.1745v-0.01018a5.17 5.0681 0 0 0-1.1429-3.0619 5.1585 5.105 0 0 0-4.1551-2.0174z",
    style: {
      fill: "#e5ac09",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.37 79.082a5.1585 5.105 0 0 0-0.0706 1e-3 5.1585 5.105 0 0 0-5.0398 5.2173 5.1585 5.105 0 0 0 2.0534 3.9639 5.4941 5.5416 0 0 0 2.3072 0.45692 5.4941 5.5416 0 0 0 5.3734-5.6579l-2.9e-4 -0.01104a5.4941 5.5416 0 0 0-0.32789-1.7609 5.1585 5.105 0 0 0-4.2953-2.2094z",
    style: {
      fill: "#edd720",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.43 82.638a0.49954 0.85389 0 0 1-0.48857 0.87184 0.49954 0.85389 0 0 1-0.51028-0.83468 0.49954 0.85389 0 0 1 0.48805-0.87267 0.49954 0.85389 0 0 1 0.51077 0.83382",
    style: {
      fill: "#483e37",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m165.77 84.919a2.7812 2.5332 0 0 0 2.8365 2.3804 2.7812 2.5332 0 0 0 2.7154-2.3804z",
    style: {
      fill: "#483e37",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.47 85.972a2.7812 2.5332 0 0 0-1.855 0.63462 2.7812 2.5332 0 0 0 1.9784 0.69809 2.7812 2.5332 0 0 0 1.7802-0.63384 2.7812 2.5332 0 0 0-1.8574-0.69835 2.7812 2.5332 0 0 0-0.0463-5.6e-4z",
    style: {
      fill: "#f07768",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.89 80.431c-3.1797-2.6439-7.4108 0.53648-6.7493 3.7608 0.0439-3.3918 3.766-5.2175 6.7493-3.7608z",
    style: {
      fill: "#fcf2c8",
      fontVariationSettings: "normal",
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.43 82.638a0.49954 0.85389 0 0 1-0.48856 0.87184 0.49954 0.85389 0 0 1-0.51029-0.83468 0.49954 0.85389 0 0 1 0.48806-0.87267 0.49954 0.85389 0 0 1 0.51077 0.83382",
    style: {
      fill: "#483e37",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.37 79.081a5.1585 5.105 0 0 0-0.0704 0.0012 5.1585 5.105 0 0 0-5.0401 5.2171 5.1585 5.105 0 0 0 1.791 3.7542 5.17 5.0681 0 0 0 5e-3 0.0052 5.17 5.0681 0 0 0 3.5556 1.2864 5.17 5.0681 0 0 0 5.0563-5.1745v-0.01016a5.17 5.0681 0 0 0-1.1429-3.0619 5.1585 5.105 0 0 0-4.1551-2.0174z",
    style: {
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 0.50669,
      stroke: "#000"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.66129 0 0 .65443 50.992 33.484)",
    style: {
      strokeWidth: 1.9256
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m209.59 69.625a7.8007 7.8007 0 0 0-0.10644 0.0018 7.8007 7.8007 0 0 0-7.6216 7.972 7.8007 7.8007 0 0 0 2.7084 5.7367 7.818 7.7443 0 0 0 8e-3 8e-3 7.818 7.7443 0 0 0 5.3767 1.9656 7.818 7.7443 0 0 0 7.6461-7.9069v-0.01556a7.818 7.7443 0 0 0-1.7282-4.6788 7.8007 7.8007 0 0 0-6.2833-3.0827z",
    style: {
      fill: "#d2c07f",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.59 69.625a7.8007 7.8007 0 0 0-0.10682 0.0016 7.8007 7.8007 0 0 0-7.6212 7.9723 7.8007 7.8007 0 0 0 3.1052 6.0571 8.3081 8.4679 0 0 0 3.489 0.6982 8.3081 8.4679 0 0 0 8.1255-8.6455l-4.5e-4 -0.01687a8.3081 8.4679 0 0 0-0.49581-2.6908 7.8007 7.8007 0 0 0-6.4953-3.376z",
    style: {
      fill: "#d0cfac",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m208.16 75.06a0.75541 1.3048 0 0 1-0.7388 1.3322 0.75541 1.3048 0 0 1-0.77166-1.2754 0.75541 1.3048 0 0 1 0.73804-1.3335 0.75541 1.3048 0 0 1 0.77238 1.2741",
    style: {
      fill: "#404040",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.65 78.545a4.2056 3.8709 0 0 0 4.2893 3.6374 4.2056 3.8709 0 0 0 4.1062-3.6374z",
    style: {
      fill: "#404040",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.74 80.153a4.2056 3.8709 0 0 0-2.8051 0.96974 4.2056 3.8709 0 0 0 2.9918 1.0667 4.2056 3.8709 0 0 0 2.692-0.96854 4.2056 3.8709 0 0 0-2.8087-1.0671 4.2056 3.8709 0 0 0-0.0701-8.55e-4z",
    style: {
      fill: "#c9948f",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m213.25 71.686c-4.8082-4.04-11.207 0.81976-10.206 5.7467 0.0664-5.1829 5.695-7.9727 10.206-5.7467z",
    style: {
      fill: "#eaeacd",
      fontVariationSettings: "normal",
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m212.69 75.06a0.75541 1.3048 0 0 1-0.7388 1.3322 0.75541 1.3048 0 0 1-0.77165-1.2754 0.75541 1.3048 0 0 1 0.73803-1.3335 0.75541 1.3048 0 0 1 0.77239 1.2741",
    style: {
      fill: "#404040",
      paintOrder: "markers fill stroke"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.59 69.625a7.8007 7.8007 0 0 0-0.10646 0.0018 7.8007 7.8007 0 0 0-7.6216 7.972 7.8007 7.8007 0 0 0 2.7084 5.7367 7.818 7.7443 0 0 0 8e-3 8e-3 7.818 7.7443 0 0 0 5.3767 1.9656 7.818 7.7443 0 0 0 7.6461-7.9069v-0.01553a7.818 7.7443 0 0 0-1.7282-4.6788 7.8007 7.8007 0 0 0-6.2833-3.0827z",
    style: {
      fill: "none",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "round",
      strokeWidth: 0.77022,
      stroke: "#000"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m74.513 125.48v5.3651c0 3.0209 2.3571 5.4699 5.2647 5.4699h11.283v1.6676l3.6874-4.0397-3.6874-4.0397v1.6676h-11.283c-0.38487 0-0.69747-0.32478-0.69747-0.72553v-5.3651z",
    style: {
      fillRule: "evenodd",
      fill: "#1b7387",
      strokeWidth: 0.6,
      stroke: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.92,
    y: 78.205,
    width: 3.9976,
    height: 3.7354,
    style: {
      fill: "#2396af",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "bevel",
      strokeWidth: 0.3,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.92,
    y: 70.72,
    width: 3.9976,
    height: 3.7354,
    style: {
      fill: "#0bd6aa",
      paintOrder: "markers fill stroke",
      strokeLinejoin: "bevel",
      strokeWidth: 0.3,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 114.8512,
    y: 73.700203,
    style: {
      fill: "#ffffff",
      fontFamily: "Verdana",
      fontSize: "6.35px",
      letterSpacing: 0,
      lineHeight: 1.25,
      strokeOpacity: 0.7,
      strokeWidth: 0,
      stroke: "#000000",
      wordSpacing: 0
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 114.8512,
    y: 73.700203,
    style: {
      fill: "#ffffff",
      fontFamily: "Verdana",
      fontSize: "6.35px",
      strokeOpacity: 0.7,
      strokeWidth: 0,
      stroke: "#000000"
    }
  }, "Prognosis")), /*#__PURE__*/React.createElement("text", {
    x: 114.8512,
    y: 81.648918,
    style: {
      fill: "#ffffff",
      fontFamily: "Verdana",
      fontSize: "6.35px",
      letterSpacing: 0,
      lineHeight: 1.25,
      strokeOpacity: 0.7,
      strokeWidth: 0,
      stroke: "#000000",
      wordSpacing: 0
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 114.8512,
    y: 81.648918,
    style: {
      fill: "#ffffff",
      fontFamily: "Verdana",
      fontSize: "6.35px",
      strokeOpacity: 0.7,
      strokeWidth: 0,
      stroke: "#000000"
    }
  }, "Baseline"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentSafetySystemC);
export default __webpack_public_path__ + "static/media/AssessmentSafetySystemC.bbed78bd28b07fae34660f1c290aaa6d.svg";
export { ForwardRef as ReactComponent };